import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// import SettingsSecurity from './settingsSecurity/SettingsSecurity';
import SettingsNotifications from './settingsNotifications/SettingsNotifications';
import SettingsShipping from './settingsShipping/SettingsShipping';
import ShopSettingsDesign from './settingsDesign/SettingsDesign';
import SettingsMarketing from './settingsMarketing/SettingsMarketing';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import SettingsSecurity from './settingsSecurity/SettingsSecurity';
import SettingsConvenienceFee from './settingsConvenienceFee/SettingsConvenienceFee';
import SettingsDiscounts from './settingsDiscounts/SettingsDiscounts';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import ShopSettingsWebhooks from './settingsWebhooks/SettingsWebhooks';
import { allRoutes } from '../../lib/constants/route';
import PSP from './psp/PSP';
import ShopSettings from './settingsShop/ShopSettings';
import CommunicationSettings from './settingsCommunication/CommunicationSettings';
import GeneralSettings from './settingsGeneral/GeneralSettings';
import ProfileSettings from './settingsProfile/ProfileSettings';
import EmployeeSettings from './settingsEmployee/EmployeeSettings';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { isAgencyOnlySession } from '../../lib/api/agency-shell-init';
import APIKeySettings from './settingsAPIKeys/APIKeySettings';
import SubscriptionSettings from './settingsSubscription/SubscriptionSettings';
import SettingsTara from './settingsTara/SettingsTara';
// Phase 1 (custom roles) — owner-only DB-backed Roles management page.
import SettingsRoles from './settingsRoles/SettingsRoles';
// Phase 13 — Team management was moved out of `/settings/*` so the sidebar
// stays in main-menu mode while the user is on the page. The old route is
// preserved as a redirect to avoid breaking deep-links from emails/docs.

const SettingsPage = () => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;

  // 2026-09-07 — invite-only employees hold no seller JWT, and every
  // seller-centric settings page (General → users/settings, Profile → seller
  // registration/password) 401'd for them. Route those two paths to the
  // employee page instead; seller sessions keep the original pages.
  const sellerToken = useSelector(
    (state: RootState) => state.auth?.authorization?.accessToken?.sellerToken
  );
  const agencyToken = useSelector(
    (state: RootState) => state.auth?.agency?.accessToken
  );
  const isWhiteLabel = useSelector(
    (state: RootState) => state.UI?.isWhiteLabel ?? false
  );
  const agencyOnly = isAgencyOnlySession(agencyToken, sellerToken, isWhiteLabel);

  useEffect(() => {
    if (currentPath === '/settings') {
      navigate('/settings/general');
    }
  }, [currentPath, navigate]);

  return (
    <PageWrapperMain>
      <div className='subPage settingsPage'>
        <SubPageContentHolder>
          <Routes>
            {allRoutes['/settings/general'] && (
              <Route
                path='general/*'
                element={agencyOnly ? <EmployeeSettings /> : <GeneralSettings />}
              />
            )}
            {allRoutes['/settings/appearance'] && (
              <Route path='appearance/*' element={<ShopSettingsDesign />} />
            )}
            {allRoutes['/settings/payments'] && (
              <Route path='payments/*' element={<PSP />} />
            )}
            {allRoutes['/settings/shipping'] && (
              <Route path='shipping/*' element={<SettingsShipping />} />
            )}
            {allRoutes['/settings/convenienceFee'] && (
              <Route
                path='convenienceFee/*'
                element={<SettingsConvenienceFee />}
              />
            )}
            {allRoutes['/settings/discounts'] && (
              <Route path='discounts/*' element={<SettingsDiscounts />} />
            )}
            {allRoutes['/settings/notifications'] && (
              <Route
                path='notifications/*'
                element={<SettingsNotifications />}
              />
            )}
            {allRoutes['/settings/webhooks'] && (
              <Route path='webhooks/*' element={<ShopSettingsWebhooks />} />
            )}
            {allRoutes['/settings/marketing'] && (
              <Route path='marketing/*' element={<SettingsMarketing />} />
            )}
            {allRoutes['/settings/security'] && (
              <Route path='security/*' element={<SettingsSecurity />} />
            )}
            {allRoutes['/settings/profile'] && (
              <Route
                path='profile/*'
                element={agencyOnly ? <EmployeeSettings /> : <ProfileSettings />}
              />
            )}
            {allRoutes['/settings/subscription'] && (
              <Route path='subscription/*' element={<SubscriptionSettings />} />
            )}
            {allRoutes['/settings/api-keys'] && (
              <Route path='api-keys/*' element={<APIKeySettings />} />
            )}
            {allRoutes['/settings/communication'] && (
              <Route
                path='communication/*'
                element={<CommunicationSettings />}
              />
            )}
            {allRoutes['/settings/brand'] && (
              <Route path='brand/*' element={<ShopSettings />} />
            )}
            {allRoutes['/settings/tara'] && (
              <Route path='tara/*' element={<SettingsTara />} />
            )}
            {allRoutes['/settings/team'] && (
              <Route path='team/*' element={<Navigate to='/team' replace />} />
            )}
            {/* Phase 1 (custom roles) — owner-only Roles management. The page
                itself gates on `settings.manage_org`; the sidebar link is
                gated the same way so non-owners never see it. */}
            {allRoutes['/settings/roles'] && (
              <Route path='roles/*' element={<SettingsRoles />} />
            )}
          </Routes>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default SettingsPage;
